<template>
  <div>
    <PageLoader />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="black" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap>
      <v-flex xs12 md12 px-md-3 px-lg-3 px-xl-3>
        <v-layout wrap>
          <v-flex xs6>
            <span class="homeTop">Products</span>
          </v-flex>
          <v-flex xs6 text-right>
            <v-dialog
              :retain-focus="false"
              v-model="dialog"
              persistent
              max-width="800px"
              :key="dialog"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined v-bind="attrs" v-on="on"> Add </v-btn>
              </template>
              <v-card>
                <v-form v-model="addslider" ref="addcat">
                  <v-card-title>
                    <span class="headline">Add Product</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-layout justify-center wrap>
                        <v-flex xs12>
                          <v-text-field
                            class="homeText"
                            outlined
                            dense
                            v-model="product.order"
                            type="number"
                            required
                            label=" Order"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            class="homeText"
                            outlined
                            dense
                            v-model="product.name"
                            label=" Name of the Product"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            class="homeText"
                            outlined
                            dense
                            v-model="product.title"
                            :rules="titleRule"
                            required
                            label=" Title of the Product"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 pb-5>
                          <span class="homeText"
                            >Description of the Product</span
                          >
                          <div id="app">
                            <vue-editor
                              v-model="product.description"
                            ></vue-editor>
                          </div>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            class="homeText"
                            outlined
                            dense
                            :rules="[rules.required]"
                            v-model="product.weblink"
                            required
                            label=" Website Link"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            class="homeText"
                            outlined
                            dense
                            :rules="[rules.required]"
                            v-model="product.applink"
                            required
                            label=" App Link"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                            class="homeText"
                            outlined
                            dense
                            multiple
                            :items="categoryArray"
                            item-text="name"
                            item-value="_id"
                            v-model="product.category"
                            label=" Select Category"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                            class="homeText"
                            outlined
                            dense
                            multiple
                            :items="subcategoryArray"
                            item-text="name"
                            item-value="_id"
                            v-model="product.subCategory"
                            label=" Select SubCategory"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                            class="homeText"
                            outlined
                            dense
                            :items="clientArray"
                            item-text="company"
                            item-value="_id"
                            v-model="product.client"
                            label=" Select Client"
                          ></v-select>
                        </v-flex>
                        <v-layout justify-center wrap>
                          <v-flex xs12>
                            <span class="homeText">Select Color</span>
                          </v-flex>
                        </v-layout>
                        <v-flex xs12>
                          <v-color-picker
                            dot-size="25"
                            hide-mode-switch
                            mode="hexa"
                            swatches-max-height="200"
                            v-model="product.color"
                          ></v-color-picker>
                        </v-flex>
                        <v-layout justify-center wrap>
                          <v-flex xs12>
                            <span class="homeText">Select Font Color</span>
                          </v-flex>
                        </v-layout>
                        <v-flex xs12>
                          <v-color-picker
                            dot-size="25"
                            hide-mode-switch
                            mode="hexa"
                            swatches-max-height="200"
                            v-model="product.fontColor"
                          ></v-color-picker>
                        </v-flex>
                        <v-layout justify-start wrap pl-2 pb-5>
                          <v-flex xs12>
                            <img
                              v-if="imagePreview"
                              :src="imagePreview"
                              v-show="showPreview"
                              width="150px"
                              height="150px"
                              class="align-center"
                              contain
                            />
                          </v-flex>
                          <v-flex xs12 sm12 md12 lg12>
                            <v-btn
                              width="180px"
                              block
                              tile
                              depressed
                              :ripple="false"
                              class="text-capitalize"
                              color="#F6F5FF"
                              @click="$refs.showImage.click()"
                            >
                              <v-layout justify-center wrap>
                                <v-flex xs2 sm2 md2 text-left>
                                  <v-icon style="color: #000000"
                                    >mdi-upload</v-icon
                                  >
                                </v-flex>
                                <v-flex xs10 sm8 md8>
                                  <span class="image">UPLOAD IMAGE </span>
                                </v-flex>
                              </v-layout>
                            </v-btn>
                            <input
                              v-show="false"
                              accept="image/*"
                              id="file"
                              ref="showImage"
                              multiple="multiple"
                              type="file"
                              @change="showImage"
                            />
                          </v-flex>
                        </v-layout>
                        <v-layout justify-start wrap pl-2 pb-5>
                          <v-flex xs12>
                            <img
                              v-if="imagePreviewCover"
                              :src="imagePreviewCover"
                              v-show="showPreviewCover"
                              width="150px"
                              height="150px"
                              class="align-center"
                              contain
                            />
                          </v-flex>
                          <v-flex xs12 sm12 md12 lg12>
                            <v-btn
                              width="180px"
                              block
                              tile
                              depressed
                              :ripple="false"
                              class="text-capitalize"
                              color="#F6F5FF"
                              @click="$refs.showImageCover.click()"
                            >
                              <v-layout justify-center wrap>
                                <v-flex xs2 sm2 md2 text-left>
                                  <v-icon style="color: #000000"
                                    >mdi-upload</v-icon
                                  >
                                </v-flex>
                                <v-flex xs10 sm8 md8>
                                  <span class="image">UPLOAD COVER IMAGE </span>
                                </v-flex>
                              </v-layout>
                            </v-btn>
                            <input
                              v-show="false"
                              accept="image/*"
                              id="file"
                              ref="showImageCover"
                              multiple="multiple"
                              type="file"
                              @change="showImageCover"
                            />
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">
                      Close
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="validateInput()">
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start v-if="list.length > 0">
          <v-flex v-for="(item, i) in list" :key="i" md3 pa-4>
            <v-card style="line-height: 16px">
              <v-img
                style="width: 100%"
                :src="mediaURL + item.image"
                cover
                height="200px"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="#FF2323"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-layout wrap justify-center px-2 py-4>
                <v-flex xs12 text-center>
                  <span class="showLine homeName">
                    <router-link
                      style="text-decoration: none; color: black"
                      :to="'/productDetails?product=' + item._id"
                    >
                      {{ item.name }}
                    </router-link> </span
                  ><br /><br />
                  <span
                    class="showLine2"
                    style="
                      font-size: 13px;
                      font-weight: bold;
                      color: #000000;
                      font-family: poppinsregular;
                    "
                  >
                    {{ item.title }} </span
                  ><br /><br />
                </v-flex>
                <v-flex pt-5 xl6 lg6 md6 pb-2 sm6 xs6 px-5 justify-center>
                  <v-dialog v-model="item.delete" max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        class="mr-2"
                        outlined
                        block
                        v-on="on"
                        v-bind="attrs"
                        color="red"
                      >
                        Delete
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title
                        >Are you sure you want to delete this
                        Product?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="item.delete = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItem(item)"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
                <v-flex pt-5 xl6 lg6 md6 pb-2 sm6 xs6 px-5 justify-center>
                  <v-btn
                    small
                    class="mr-2"
                    outlined
                    block
                    color="green"
                    :to="'/productDetails?product=' + item._id"
                  >
                    Edit
                  </v-btn>
                </v-flex>
                <br />
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout v-else justify-center wrap pt-5>
          <v-flex xs12 text-center>
            <span class="homeText">No Data Found.....</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import store from "./../../store";
import { VueEditor } from "vue2-editor";
// import ImageComp from "@/components/Common/singleImage";
export default {
  components: {
    // ImageComp,
    VueEditor,
  },
  data() {
    return {
      product: {
        name: null,
        title: null,
        description: null,
        category: null,
        subCategory: null,
        client: null,
        color: null,
        fontColor: null,
        order: null,
        weblink: null,
        applink: null,
      },
      titleRule: [(v) => v.length <= 65 || "Max 65 characters"],
      rules: {
        required: (value) =>
          /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/.test(
            value
          ) || "Must be link",
        min: (v) => v.length >= 10 || "Min 10 characters",
      },
      addslider: false,
      list: [],
      editingitem: [],
      categoryArray: [],
      subcategoryArray: [],
      clientArray: [],
      dialog: false,
      editdialog: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      imageArray: [],
      imageError: "",
      imageCoverError: "",
      formData: new FormData(),
      selectedFiles: [],
      image: null,
      imagePreview: "",
      showPreview: false,
      file: null,
      imagePreviewCover: "",
      showPreviewCover: false,
      file1: null,
      coverImageArray: [],
      formDataCover: new FormData(),
      selectedImage: null,
      topimageFile: null,
      coverimageFile: null,
      imageFiles: [],
      id: null,
    };
  },
  mounted() {
    this.getList();
    this.getCat();
    this.getClient();
    this.getSub();
  },
  methods: {
    winStepper(window_data) {
      if (window_data.type == "image") {
        this.imageArray = window_data.imageArray;
        this.imageFiles.push(window_data.selectedFiles);
      } else if (window_data.type == "imageRemoval") {
        var values = this.formData.getAll("photos");
        values.splice(window_data.removalItem, 1);
        this.formData.set("photos", values);
        this.imageArray = window_data.imageArray;
      } else if (window_data.type == "topimage") {
        this.topimageFile = window_data.selectedFiles;
      } else if (window_data.type == "coverimage") {
        this.coverimageFile = window_data.selectedFiles;
      }
    },
    validateInput() {
      if (!this.product.name) {
        this.msg = "Please Provide Name of the Product";
        this.showSnackBar = true;
        return;
      } else if (!this.product.title) {
        this.msg = "Please Provide Title of the Product";
        this.showSnackBar = true;
        return;
      } else if (!this.product.description) {
        this.msg = "Please Provide Description of the Product";
        this.showSnackBar = true;
        return;
      } else if (!this.product.category) {
        this.msg = "Please Provide Category of the Product";
        this.showSnackBar = true;
        return;
      } else if (!this.product.client) {
        this.msg = "Please Provide Client of the Product";
        this.showSnackBar = true;
        return;
      } else if (!this.product.color) {
        this.msg = "Please Provide Color of the Product";
        this.showSnackBar = true;
        return;
      } else if (!this.product.fontColor) {
        this.msg = "Please Provide Font Color of the Product";
        this.showSnackBar = true;
        return;
      } else {
        this.add();
      }
    },
    getList() {
      store.commit("appLoading", true);
      axios({
        method: "GET",
        url: "/product/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.list = response.data.data;
          store.commit("appLoading", false);
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },
    getCat() {
      store.commit("appLoading", true);
      axios({
        method: "GET",
        url: "/product/category/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.categoryArray = response.data.data;
          store.commit("appLoading", false);
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },
    getSub() {
      store.commit("appLoading", true);
      axios({
        method: "GET",
        url: "/product/subcategory/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.subcategoryArray = response.data.data;
          store.commit("appLoading", false);
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },
    getClient() {
      store.commit("appLoading", true);
      axios({
        method: "GET",
        url: "/home/client/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.clientArray = response.data.data;
          store.commit("appLoading", false);
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },
    add() {
      this.product["color"] = this.product.color.hexa;
      this.product["fontColor"] = this.product.fontColor.hexa;
      axios({
        method: "post",
        url: "/product/add",
        data: this.product,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.id = response.data.id;
            if (this.imagePreview) {
              this.uploadImage(this.id);
            }
            if (this.imagePreviewCover) {
              this.uploadCoverImage(this.id);
            }
            Object.keys(this.product).forEach(
              (key) => (this.product[key] = null)
            );
            this.msg = "Added Successully";
            this.showSnackBar = true;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    showImageCover(e) {
      this.file1 = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImageCover.value = null;
        this.imagePreviewCover = e.target.result;
      };
      if (this.file1.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showPreviewCover = true;
      if (this.file1) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file1.name)) {
          reader.readAsDataURL(this.file1);
        }
      }
    },
    showImage(e) {
      this.file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImage.value = null;
        this.imagePreview = e.target.result;
      };
      if (this.file.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showPreview = true;
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },
    uploadImage(item) {
      store.commit("appLoading", true);
      let formData = new FormData();
      formData.append("image", this.file);
      formData.append("id", item);
      axios({
        method: "POST",
        url: "/product/image",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          store.commit("appLoading", false);
          if (response.data.status == true) {
            this.msg = "Upload Successfully";
            this.showSnackBar = true;
            (this.imagePreview = null), (this.dialog = false);
            this.editdialog = false;
            this.getList();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.msg = "Can't Upload Cover Image.. Please Try Again Later";
          this.showSnackBar = true;
          console.log(err);
        });
    },
    uploadCoverImage(item) {
      store.commit("appLoading", true);
      let formData = new FormData();
      formData.append("id", item);
      formData.append("image", this.file1);
      axios({
        method: "POST",
        url: "/product/coverimage",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          store.commit("appLoading", false);
          if (response.data.status == true) {
            this.msg = "Upload Successfully";
            this.showSnackBar = true;
            (this.imagePreviewCover = null), (this.dialog = false);
            this.editdialog = false;
            this.getList();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.msg = "Can't Upload Cover Image.. Please Try Again Later";
          this.showSnackBar = true;
          console.log(err);
        });
    },
    deleteItem(r) {
      var data = {};
      data["id"] = r._id;
      axios({
        url: "/product/remove",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;
            this.getList();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.v-application .primary {
  background-color: red !important;
}
.showLine {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.showLine2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>